export interface RoutableNotification {
  type?: string | null;
  action_url?: string | null;
  related_booking_id?: string | null;
  related_listing_id?: string | null;
}

const APP_SCHEMES = new Set(["voltyshare:", "com.160418.voltyshare:", "com.voltyshare.app:"]);
const APP_HOSTS = new Set(["voltyshare.com", "www.voltyshare.com"]);

export function notificationUrl(notification: RoutableNotification) {
  if (notification.action_url) return safeAppUrl(notification.action_url);
  if (notification.type === "message") {
    return notification.related_booking_id
      ? `/messages/booking-${notification.related_booking_id}`
      : "/messages";
  }
  if ((notification.type === "booking" || notification.type === "payment") && notification.related_booking_id) {
    return `/dashboard?booking=${notification.related_booking_id}`;
  }
  if (notification.type === "vehicle") return "/my-ev?tab=reminders";
  if (notification.type === "safety" && notification.related_booking_id) {
    return `/dashboard?booking=${notification.related_booking_id}`;
  }
  if (notification.related_listing_id) return `/listing/${notification.related_listing_id}`;
  return "/profile";
}

export function safeAppUrl(value: string) {
  if (value.startsWith("/") && !value.startsWith("//")) return value;
  try {
    const url = new URL(value);
    if (APP_HOSTS.has(url.hostname)) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
    if (APP_SCHEMES.has(url.protocol)) return appSchemeToPath(url);
  } catch {
    return "/profile";
  }
  return "/profile";
}

function appSchemeToPath(url: URL) {
  if (url.pathname && url.pathname !== "/") return `${url.pathname}${url.search}${url.hash}`;
  if (url.hostname) return `/${url.hostname}${url.search}${url.hash}`;
  return "/profile";
}
